import React from 'react';
import {ProductView} from './container';

export const ProductScreen = ({navigation}: {navigation: any}) => {
    return <ProductView />
}